export const combineArrayElements = (array = [], separator) => {
    // Initialize a string to store the combined elements.
    let combinedString = '';

    // Iterate through the array and add each element to the combined string, separated by "|".
    for (let i = 0; i < array.length; i++) {
        combinedString += array[i] + separator;
    }

    // Remove the trailing "|" character.
    combinedString = combinedString.slice(0, -1);

    return combinedString;
};
